<template>
  <div class="sidebar__link-wrapper">
    <router-link to="/audit-mentors" class="sidebar__link">
      <UserIcon class="w-5 h-5" />
      <p>Mentors</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/audit-warnings" class="sidebar__link">
      <ExclamationTriangleIcon class="w-5 h-5" />
      <p>Tarixi</p>
    </router-link>
  </div>
</template>

<script setup>
import {
  UserIcon,
  ExclamationTriangleIcon,
} from "@heroicons/vue/24/outline";
</script>

<style></style>
